import React, { useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import styles from './index.module.scss';
import Layout from '../layout';
import GlassButton from '../glass-button';
import FooterLinks from '../footer-links';

const PHONE_REGEX = /^380\d{9}$/;

const ErrorIcon = () => (
  <i className={styles.errorIcon}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="10" fill="#F9524D" />
      <path
        d="M10.9444 5L10.7407 12.555H9.25926L9.04938 5H10.9444ZM9 14.894C9 14.5752 9.09053 14.3111 9.2716 14.1019C9.45679 13.8877 9.69959 13.7806 10 13.7806C10.3045 13.7806 10.5473 13.8877 10.7284 14.1019C10.9095 14.3111 11 14.5752 11 14.894C11 15.2029 10.9095 15.4644 10.7284 15.6787C10.5473 15.8929 10.3045 16 10 16C9.69959 16 9.45679 15.8929 9.2716 15.6787C9.09053 15.4644 9 15.2029 9 14.894Z"
        fill="white"
      />
    </svg>
  </i>
);

// Перший екран опитувальника: авторизація за номером телефону.
// Сам запит робить батьківський флоу — тут лише перевірка формату.
const PhoneScreen = ({ onSubmit, onTerms, onCookies }) => {
  const [phone, setPhone] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Успішний onSubmit веде на інший екран, і цей уже розмонтований —
  // без цієї перевірки React лається на setState після unmount.
  const isMountedRef = useRef(true);

  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    []
  );

  const fullPhone = `380${phone.replace(/\D/g, '')}`;
  const isPhoneValid = PHONE_REGEX.test(fullPhone);
  // Помилку показуємо лише коли користувач уже щось ввів — порожнє поле
  // на старті не підсвічуємо.
  const hasPhoneError = isTouched && !isPhoneValid;

  const handleSubmit = async () => {
    if (!isPhoneValid) return;

    try {
      setIsSubmitting(true);
      await onSubmit(fullPhone);
    } finally {
      if (isMountedRef.current) setIsSubmitting(false);
    }
  };

  return (
    <Layout contentClassName={styles.content}>
      <div className={styles.titleContainer}>
        <p className={styles.title}>
          Наступна зупинка:
          <br />
          опитувальник 📝
        </p>
        <p className={styles.subtitle}>
          та для початку будь ласка введи номер телефону для авторизації
        </p>
      </div>
      <div className={styles.phoneContainer}>
        <div className={styles.labelContainer}>
          <p className={styles.codeLabel}>Код</p>
          <p>
            Номер телефону<span>*</span>
          </p>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.code}>+380</div>
          <div className={styles.inputWrapper}>
            <InputMask
              mask="(99) 999-99-99"
              maskChar="_"
              alwaysShowMask
              value={phone}
              onChange={(event) => {
                setPhone(event.target.value);
                setIsTouched(true);
              }}
              onBlur={() => setIsTouched(true)}
              className={classNames(
                styles.input,
                hasPhoneError && styles.error
              )}
            >
              {(inputProps) => <input {...inputProps} type="tel" />}
            </InputMask>
            {hasPhoneError && <ErrorIcon />}
          </div>
        </div>
        {hasPhoneError && (
          <p className={styles.errorText}>Перевір коректність номеру</p>
        )}
      </div>
      <GlassButton
        className={styles.submitButton}
        onClick={handleSubmit}
        disabled={!isPhoneValid}
        isLoading={isSubmitting}
      >
        Далі
      </GlassButton>
      <FooterLinks
        className={styles.footerLinks}
        onTerms={onTerms}
        onCookies={onCookies}
      />
    </Layout>
  );
};

export default PhoneScreen;
